var Assam = "Ассам";
var Bihar = "Бихар";
var Chandigarh = "Чандигарх";
var Chhattisgarh = "Чхаттисгарх";
var Delhi = "Дели";
var Goa = "Гоа";
var Gujarat = "Гуджарат";
var Haryana = "Харьяна";
var Jharkhand = "Джаркханд";
var Karnataka = "Карнатака";
var Kerala = "Керала";
var Lakshwadeep = "Лакшадвип";
var Maharashtra = "Махараштра";
var Manipur = "Манипур";
var Meghalaya = "Мегхалая";
var Mizoram = "Мизорам";
var Nagaland = "Нагаленд";
var Orrisa = "Одиша";
var Puducherry = "Пондичерри";
var Punjab = "Пенджаб";
var Rajasthan = "Раджастхан";
var Sikkim = "Сикким";
var Telangana = "Телингана";
var Tripura = "Трипура";
var Uttrakhand = "Уттаракханд";
var INStates = {
	"Andaman and Nicobar Islands": "Андаманские и Никобарские острова",
	"Andhra Pradesh": "Андхра-Прадеш",
	"Arunachal Pradesh": "Аруначал-Прадеш",
	Assam: Assam,
	Bihar: Bihar,
	Chandigarh: Chandigarh,
	Chhattisgarh: Chhattisgarh,
	"Dadra & Nagar Haveli": "Дадра и Нагар-Хавели",
	"Daman & Diu": "Даман и Диу",
	Delhi: Delhi,
	Goa: Goa,
	Gujarat: Gujarat,
	Haryana: Haryana,
	"Himachal Pradesh": "Химачал-Прадеш",
	"Jammu and Kashmir": "Джамму и Кашмир",
	Jharkhand: Jharkhand,
	Karnataka: Karnataka,
	Kerala: Kerala,
	Lakshwadeep: Lakshwadeep,
	"Madhya Pradesh": "Мадхья-Прадеш",
	Maharashtra: Maharashtra,
	Manipur: Manipur,
	Meghalaya: Meghalaya,
	Mizoram: Mizoram,
	Nagaland: Nagaland,
	Orrisa: Orrisa,
	Puducherry: Puducherry,
	Punjab: Punjab,
	Rajasthan: Rajasthan,
	Sikkim: Sikkim,
	"Tamil Nadu": "Тамилнад",
	Telangana: Telangana,
	Tripura: Tripura,
	"Uttar Pradesh": "Уттар-Прадеш",
	Uttrakhand: Uttrakhand,
	"West Bengal": "Западная Бенгалия"
};

export { Assam, Bihar, Chandigarh, Chhattisgarh, Delhi, Goa, Gujarat, Haryana, Jharkhand, Karnataka, Kerala, Lakshwadeep, Maharashtra, Manipur, Meghalaya, Mizoram, Nagaland, Orrisa, Puducherry, Punjab, Rajasthan, Sikkim, Telangana, Tripura, Uttrakhand, INStates as default };
